module.exports = __webpack_public_path__ + "static/media/castello-branco-advogados-associados-logo-branding-768x591.b170c50a.jpg";